import { motion } from "framer-motion";
import { Instagram, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { LogoMark } from "./Logo";
import { WHATSAPP_URL, INSTAGRAM_URL, CRP } from "./content";

export const Contact = () => (
  <section id="contato" data-testid="contact-section" className="relative py-24 md:py-36 overflow-hidden">
    <div className="absolute inset-x-0 top-0 h-full bg-gradient-to-b from-cream via-blush/60 to-butter/70" />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
      <Reveal><div className="flex justify-center"><Eyebrow>Contato</Eyebrow></div></Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display text-[2.6rem] sm:text-6xl lg:text-7xl text-ink leading-[1.02] tracking-tight">
          Vamos conversar sobre <span className="italic text-clay">a sua história?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-7 text-base sm:text-lg text-ink/75 max-w-xl mx-auto">Me envie uma mensagem no WhatsApp para tirar dúvidas, saber valores e agendar a primeira sessão.</p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <motion.a whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }} data-testid="contact-whatsapp-btn" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-3 rounded-full bg-ink text-cream px-8 py-4 text-lg hover:bg-sage transition-colors">
            <MessageCircle size={20} /> Chamar no WhatsApp
          </motion.a>
          <a data-testid="contact-instagram-link" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-ink/25 px-6 py-4 text-ink hover:bg-cream transition-colors">
            <Instagram size={18} /> @psi.anafalaschi
          </a>
        </div>
      </Reveal>
    </div>
    <footer data-testid="site-footer" className="relative max-w-7xl mx-auto px-5 sm:px-8 mt-28 pt-8 border-t border-ink/15 flex flex-col sm:flex-row gap-4 items-center justify-between text-sm text-ink/70">
      <span className="flex items-center gap-3"><LogoMark className="w-7 h-7" /> Ana Falaschi · Psicóloga · {CRP}</span>
      <span>© {new Date().getFullYear()} · Atendimento on-line</span>
    </footer>
  </section>
);
